import React from 'react';

import { TournamentStore } from './TournamentStore';

export const TournamentContext = React.createContext<TournamentStore | undefined>(undefined);
